export enum PaymentSource {
  Adyen = 'ADYEN',
  Amazon = 'AMAZON',
  Affirm = 'AFFIRM',
  Apple = 'APPLE',
  Braintree = 'BRAINTREE',
  BraintreeAffirm = 'BRAINTREE_AFFIRM',
  BraintreeApple = 'BRAINTREE_APPLE',
  Moda = 'MODA',
  PayPal = 'PAYPAL',
  SiteCredit = 'SITE_CREDIT'
}
